const Home = () => {
  return <p>Este es el Home</p>;
};

export default Home;
